module.exports = __webpack_public_path__ + "images/8c348ed6d29ad3a5bfad88580e2c4a03610dca029136d7203f48f934962b814a.svg";